import { HeaderCtaProps } from './types';
import CTA from 'components/shared/CTA/CTA';
import Link from 'components/shared/Link/Link';
import { cn, getColorway } from 'utils/styles';
import { getColorwayName } from 'utils/formatters';
import { Colorways } from 'types/constants';
import ChimeLogo from 'components/shared/ChimeLogo/ChimeLogo';

const HeaderCta = ({ cta, color }: HeaderCtaProps) => {
  return (
    <div
      className={cn('px-6 sm:px-14 py-4 flex justify-between h-18', getColorway(color))}
      data-testid="header-cta"
      data-theme={'dark'}>
      <Link href="/">
        <ChimeLogo
          color={getColorwayName(color) === Colorways.Inverse ? 'primary_neutral' : 'chime_green'}
          alt="Chime Home"
        />
      </Link>

      <div className="sm:min-w-[200px] h-full flex">
        <CTA cta={cta} />
      </div>
    </div>
  );
};

export default HeaderCta;
